export default __webpack_public_path__ + "static/media/rare5.6bd01ed3.png";